function u(e, o) {
  var s = {},
    l = Object.keys(e);
  for (var t = 0; t < l.length; t++) {
    var n = l[t],
      r = e[n];
    s[n] = o(r, n, e);
  }
  return s;
}
export { u as mapValues };